import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import { compareAsc, format } from "date-fns";
import moment from "moment";
import { json } from "react-router-dom";
import AttendanceCalendar from "./AttendanceCalendar";
function UserLoginReportsComp() {
    const currentDate = moment().format("YYYY-MM-DD");
    const month = moment().format("M");
    const year = moment().format("YYYY");
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let token = JSON.parse(localStorage.getItem("key"));
    useEffect(() => {
        get_numberOfLogin_in_day();
        get_numberOfLogin_in_month();
    }, []);
    const [dayLogin, setDayLogin] = useState(null);
    const [monthLogin, setMonthLogin] = useState(null);
    const [pendingLeave, setPendingLeave] = useState('0')
    const [pendingAttendanve, setPendingAttendanve] = useState('0')
    const get_numberOfLogin_in_day = async () => {
        const response = await fetch(
            SERVER_URL + `api/reports/getnumberoflogininday`,
            {
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    authorization: `bearer ${token.value}`,
                },
                body: JSON.stringify({
                    login_date: currentDate,
                }),
            }
        );
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        const result = await response.json();
        if (result.status == true) {
            setDayLogin(result.results.length);
        }
    };
    const get_numberOfLogin_in_month = async () => {
        const response = await fetch(
            SERVER_URL + `api/reports/getnumberoflogininmonth`,
            {
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    authorization: `bearer ${token.value}`,
                },
                body: JSON.stringify({
                    month: month,
                    year: year,
                }),
            }
        );
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        const result = await response.json();
        if (result.status == true) {
            setMonthLogin(result.results.length);
        }
    };

    useEffect(() => {
        pending_leave_request()
        pending_attendance_request()

    }, [])
    const pending_leave_request = async () => {
        try {
            const response = await fetch(`${SERVER_URL}api/reports/getpendingleaverequest`, {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token.value}`,
                },
                body: JSON.stringify({ month, year })
            });

            if (!response.ok) throw new Error("Failed to fetch data");

            const result = await response.json();

            if (result.status) {
                setPendingLeave(result?.results?.count_pending_leave || 0); // Default to 0 if undefined
            }
        } catch (error) {
            console.error("Error fetching pending leave requests:", error);
        }
    };
    const pending_attendance_request = async () => {
        try {
            const response = await fetch(`${SERVER_URL}api/reports/getpendingattendancerequest`, {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token.value}`,
                },
                body: JSON.stringify({ month, year })
            });

            if (!response.ok) throw new Error("Failed to fetch data");

            const result = await response.json();

            if (result.status) {
                setPendingAttendanve(result?.results?.count_pending_leave || 0); // Default to 0 if undefined
            }
        } catch (error) {
            console.error("Error fetching pending leave requests:", error);
        }
    };
    return (
        <div>
            <div className="page-header">
                <h1>Login Report</h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li><Link to="/dashboard">Dashboard </Link></li>
                    <li className="current">
                        <span>/</span>Login Report
                    </li>
                </ul>
            </div>
            <div className="row_bg">
                <div className="row">
                    <div className="col-md-3">
                        <div className="dash_white_box2 dash_white_box3 mb20">
                            <div className="logincard_blk">
                                <div className="logincard_ttl">Today's Login</div>
                                <div className="login_left">
                                    <i className="icon icon-users blue_color"></i>
                                </div>
                                <div className="login_right">
                                    <div className="logincard_count">
                                        {dayLogin ? dayLogin : 0} <span>Employee</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="dash_white_box2 dash_white_box3 mb20">
                            <div className="logincard_blk cgreen">
                                <div className="logincard_ttl">Monthly Login</div>
                                <div className="login_left">
                                    <i className="icon icon-calendar-user green_color"></i>
                                </div>
                                <div className="login_right">
                                    <div className="logincard_count">
                                        {monthLogin ? monthLogin : 0} <span>Employee</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="dash_white_box2 dash_white_box3 mb20">
                            <div className="logincard_blk">
                                <div className="logincard_ttl">Leave for Approval</div>
                                <div className="login_left">
                                    <i className="icon icon-hourglass yellow_color"></i>
                                </div>
                                <div className="login_right">
                                    <div className="logincard_count">
                                        {pendingLeave}  <span>Pending Request</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="dash_white_box2 dash_white_box3 mb20">
                            <div className="logincard_blk">
                                <div className="logincard_ttl">Regularize Attendance</div>
                                <div className="login_left">
                                    <i className="icon icon-clock orange_color"></i>
                                </div>
                                <div className="login_right">
                                    <div className="logincard_count">
                                        {pendingAttendanve} <span>Pending Request</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dash_white_box2 mb20">
                    <AttendanceCalendar />
                </div>
            </div>
        </div>
    );
}

export default UserLoginReportsComp;
